/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import { getOpeningHours } from "@/services/opening-hours";

const MUTATIONS = {
  SET_HOURS: "setHours"
};

const STATE = {
  HOURS: "hours",
  OPEN: "open"
};

export default {
  namespaced: true,
  state: {
    [STATE.HOURS]: null,
    [STATE.OPEN]: null
  },
  getters: {
    [STATE.HOURS]: state => state[STATE.HOURS],
    [STATE.OPEN]: state => state[STATE.OPEN]
  },
  mutations: {
    [MUTATIONS.SET_HOURS]: (state, { from, to, open }) => {
      state[STATE.HOURS] = { from, to };
      state[STATE.OPEN] = open;
    }
  },
  actions: {
    /**
     * @memberOf Settings
     * @public
     */
    async load({ commit }) {
      let data = await getOpeningHours();
      commit(MUTATIONS.SET_HOURS, data);
    }
  }
};
